<template>
    <modal id="lesson-modal"
           size="large"
           v-model="showModal"
           :title="generateModalTitle('lesson')"
           @submit="submit"
           :loading="loading"
           :preloader="preloader"

    >
        <form :data-url='selectedUrl ? selectedUrl : apiUrl.LESSON'
              method="POST"
              ref="form"
              enctype="multipart/form-data"
              @submit.prevent="submitData">
            <div class="row">
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('title')"
                        type="text"
                        v-model="formData.title"
                        :placeholder="$placeholder('title')"
                        :required="true"
                        :error-message="$errorMessage(errors, 'title')"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group-selectable
                        type="search-select"
                        :label="$t('course')"
                        list-value-field="title"
                        :chooseLabel="$t('course')"
                        v-model="formData.course_id"
                        :required="true"
                        :error-message="$errorMessage(errors, 'course_id')"
                        :fetch-url="`${apiUrl.TENANT_SELECTABLE_COURSE}`"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('lessons.order')"
                        type="number"
                        v-model="formData.order"
                        :placeholder="$placeholder('order')"
                        :required="true"
                        :error-message="$errorMessage(errors, 'order')"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('lessons.video_url')"
                        type="text"
                        v-model="formData.video_url"
                        :placeholder="$placeholder('lessons.video_url')"
                        :required="true"
                        :error-message="$errorMessage(errors, 'video_url')"
                    />
                </div>
            </div>
            <div class="form-group mb-0">
                <label>
                    {{ $t('attachments') }}
                </label>
                <app-input
                    type="dropzone"
                    v-model="attachments"
                    :error-message="errorMessageInArray(errors, 'attachments.0')"
                />
                <small class="text-muted">{{ $t('leave_attachment_allowed_file_types') }}</small>
            </div>
        </form>
    </modal>
</template>

<script>
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import {TENANT_SELECTABLE_COURSE} from "../../../../Config/ApiUrl";
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import {
    errorMessageInArray,
    formDataAssigner
} from "../../../../../common/Helper/Support/FormHelper";
import {axiosPost} from "../../../../../common/Helper/AxiosHelper";

export default {
    name: "LessonCreateEdit",
    components: {},
    mixins: [FormHelperMixins, ModalMixin],
    comments: {},
    data() {
        return {
            errorMessageInArray,
            formData: {
                title: '',
                course_id: '',
                order: '',
                video_url:'',
            },
            TENANT_SELECTABLE_COURSE,
            attachments: [],
        };
    },
    computed: {
    },
    methods: {
        submit() {
            this.loading = true;
            let formData = {...this.formData}
            formData = formDataAssigner(new FormData, formData);
            let url = this.apiUrl.LESSON;
            // Remove unwanted fields
            this.attachments.forEach(file => {
                formData.append('attachments[]', file)
            })
            if (this.selectedUrl) {
                formData.append('_method', "PUT");
                url = this.selectedUrl;
            }
            axiosPost(url, formData).then(({data}) => {
                this.loading = false;
                $('#lesson-modal').modal('hide');
                $('.modal-backdrop').remove();
                this.showModal = false;
                this.toastAndReload(data.message, 'lesson-table');
            }).catch(({response}) => {
                this.loading = false;
                this.message = '';
                this.errors = response.data.errors || {};
                this.fieldStatus.isSubmit = true;
                if (response.status !== 422) {
                    this.$toastr.e(response.data.message || response.statusText);
                }
            });

        },
        afterSuccess({data}) {
            this.formData = {};
            $('#lesson-modal').modal('hide');
            this.toastAndReload(data.message, 'lesson-table')
            this.$emit('input', false);
        },
        afterError(response) {
            this.loading = false;
            this.errors = response.data.errors;
        },
    }
}
</script>
